const dushi = {
  category: '都市',
  categoryId: '5',
  coverList: [
    {
      coverId: 5001,
      template: 'horizen_1',
      title: {
        titleText: '',
        color: '#FFFDF8',
        smallTitleColor: '#211621',
        smallTitleBackground: 'linear-gradient(180deg, #FFFDF8 0%, #FDDA89 100%)',
        color_mask: '#FDDA89',
        font: '飞驰标题体',
        fontSize: '63',
        // strokeColor: "#fff",
        spacing: 0,
      },
      author: {
        authorText: '',
        fontSize: '18',
        color: '#fff',
      },
      padding: 20,
      background: {
        backgroundImage: 'https://raw.githubusercontent.com/lorryrio/godblesslorry.github.io.images/master/images/cover/dushi/1-cover.png',
        textBackground: 'linear-gradient(to bottom, transparent 50%, #333046)',
      },
    },
    {
      coverId: 5002,
      template: 'horizen_1',
      title: {
        titleText: '',
        color: '#FFFFFF',
        smallTitleColor: '#000',
        smallTitleBackground: 'linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 25%, #BDBDBD 100%)',
        color_mask: '#BDBDBD',
        font: '庞门正道标题体',
        fontSize: '63',
        // strokeColor: "#fff",
        spacing: 0,
      },
      author: {
        authorText: '',
        fontSize: '18',
        color: '#fff',
      },
      padding: 20,
      background: {
        backgroundImage: 'https://raw.githubusercontent.com/lorryrio/godblesslorry.github.io.images/master/images/cover/dushi/2-cover.png',
        textBackground: 'linear-gradient(to bottom, transparent 50%, #333046)',
      },
    },
    {
      coverId: 5003,
      template: 'horizen_1',
      title: {
        titleText: '',
        color: '#FFFFFF',
        smallTitleColor: '#211621',
        smallTitleBackground: 'linear-gradient(180deg, #FFFFFF 0%, #858BBB 100%)',
        color_mask: '#858BBB',
        font: '飞驰标题体',
        fontSize: '63',
        // strokeColor: "#fff",
        spacing: 0,
      },
      author: {
        authorText: '',
        fontSize: '18',
        color: '#fff',
      },
      padding: 20,
      background: {
        backgroundImage: 'https://raw.githubusercontent.com/lorryrio/godblesslorry.github.io.images/master/images/cover/dushi/3-cover.png',
        textBackground: 'linear-gradient(to bottom, transparent 50%, #333046)',
      },
    },
    {
      coverId: 5004,
      template: 'horizen_1',
      title: {
        titleText: '',
        color: '#F6FF77',
        smallTitleColor: '#000',
        smallTitleBackground: 'linear-gradient(180deg, #F6FF77 0%, #F2944F 100%)',
        color_mask: '#F2944F',
        font: '潮字社曾玉波手书简',
        fontSize: '68',
        // strokeColor: "#fff",
        spacing: 0,
      },
      author: {
        authorText: '',
        fontSize: '18',
        color: '#fff',
      },
      padding: 20,
      background: {
        backgroundImage: 'https://raw.githubusercontent.com/lorryrio/godblesslorry.github.io.images/master/images/cover/dushi/4-cover.png',
        textBackground: 'linear-gradient(to bottom, transparent 50%, #333046)',
      },
    },
    {
      coverId: 5005,
      template: 'horizen_1',
      title: {
        titleText: '',
        color: '#FFFFFF',
        smallTitleColor: '#211621',
        smallTitleBackground: 'linear-gradient(180deg, #FFFFFF 0%, #CFACB6 100%)',
        color_mask: '#CFACB6',
        font: '联盟起艺卢帅正锐黑体',
        fontSize: '63',
        // strokeColor: "#fff",
        spacing: 0,
      },
      author: {
        authorText: '',
        fontSize: '18',
        color: '#fff',
      },
      padding: 20,
      background: {
        backgroundImage: 'https://raw.githubusercontent.com/lorryrio/godblesslorry.github.io.images/master/images/cover/dushi/5-cover.png',
        textBackground: 'linear-gradient(to bottom, transparent 50%, #333046)',
      },
    },
    {
      coverId: 5006,
      template: 'horizen_1',
      title: {
        titleText: '',
        color: '#d7d7ff7a',
        smallTitleColor: '#49657B',
        smallTitleBackground: 'linear-gradient(5deg, #FFFFFF 0%, #D7D7EF 100%)',
        color_mask: '#D7D7EF',
        font: '小白龙',
        fontSize: '73',
        strokeColor: '#fff',
        spacing: 0,
      },
      author: {
        authorText: '',
        fontSize: '18',
        color: '#fff',
      },
      padding: 20,
      background: {
        backgroundImage: 'https://raw.githubusercontent.com/lorryrio/godblesslorry.github.io.images/master/images/cover/dushi/6-cover.png',
        textBackground: 'linear-gradient(to bottom, transparent 50%, #333046)',
      },
    },
    {
      coverId: 5007,
      template: 'horizen_1',
      title: {
        titleText: '',
        color: '#FFF4D7',
        smallTitleColor: '#211621',
        smallTitleBackground: 'linear-gradient(180deg, #FFF4D7 0%, #9B471D 100%)',
        color_mask: '#9B471D',
        font: '飞驰标题体',
        fontSize: '63',
        // strokeColor: "#fff",
        spacing: 0,
      },
      author: {
        authorText: '',
        fontSize: '18',
        color: '#fff',
      },
      padding: 20,
      background: {
        backgroundImage: 'https://raw.githubusercontent.com/lorryrio/godblesslorry.github.io.images/master/images/cover/dushi/7-cover.png',
        textBackground: 'linear-gradient(to bottom, transparent 50%, #333046)',
      },
    },
    {
      coverId: 5008,
      template: 'horizen_1',
      title: {
        titleText: '',
        color: '#FFFFFF',
        smallTitleColor: '#211621',
        smallTitleBackground: 'linear-gradient(180deg, #FFFFFF 0%, #CCDFCD 100%)',
        color_mask: '#CCDFCD',
        font: '联盟起艺卢帅正锐黑体',
        fontSize: '63',
        // strokeColor: "#fff",
        spacing: 0,
      },
      author: {
        authorText: '',
        fontSize: '18',
        color: '#fff',
      },
      padding: 20,
      background: {
        backgroundImage: 'https://raw.githubusercontent.com/lorryrio/godblesslorry.github.io.images/master/images/cover/dushi/8-cover.png',
        textBackground: 'linear-gradient(to bottom, transparent 50%, #333046)',
      },
    },
    {
      coverId: 5009,
      template: 'horizen_1',
      title: {
        titleText: '',
        color: '#d7d7ff7a',
        smallTitleColor: '#49657B',
        smallTitleBackground: 'linear-gradient(5deg, #FFFFFF 0%, #D7D7EF 100%)',
        color_mask: '#D7D7EF',
        font: '小白龙',
        fontSize: '73',
        strokeColor: '#fff',
        spacing: 0,
      },
      author: {
        authorText: '',
        fontSize: '18',
        color: '#fff',
      },
      padding: 20,
      background: {
        backgroundImage: 'https://raw.githubusercontent.com/lorryrio/godblesslorry.github.io.images/master/images/cover/dushi/9-cover.png',
        textBackground: 'linear-gradient(to bottom, transparent 50%, #333046)',
      },
    },
    {
      coverId: 5010,
      template: 'horizen_1',
      title: {
        titleText: '',
        color: '#FFFFFF',
        smallTitleColor: '#000',
        smallTitleBackground: 'linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 25%, #BDBDBD 100%)',
        color_mask: '#BDBDBD',
        font: '庞门正道标题体',
        fontSize: '63',
        // strokeColor: "#fff",
        spacing: 0,
      },
      author: {
        authorText: '',
        fontSize: '18',
        color: '#fff',
      },
      padding: 20,
      background: {
        backgroundImage: 'https://raw.githubusercontent.com/lorryrio/godblesslorry.github.io.images/master/images/cover/dushi/10-cover.png',
        textBackground: 'linear-gradient(to bottom, transparent 50%, #333046)',
      },
    },
    {
      coverId: 5011,
      template: 'horizen_1',
      title: {
        titleText: '',
        color: '#d7d7ff7a',
        smallTitleColor: '#49657B',
        smallTitleBackground: 'linear-gradient(5deg, #FFFFFF 0%, #D7D7EF 100%)',
        color_mask: '#D7D7EF',
        font: '小白龙',
        fontSize: '73',
        strokeColor: '#fff',
        spacing: 0,
      },
      author: {
        authorText: '',
        fontSize: '18',
        color: '#fff',
      },
      padding: 20,
      background: {
        backgroundImage: 'https://raw.githubusercontent.com/lorryrio/godblesslorry.github.io.images/master/images/cover/dushi/11-cover.png',
        textBackground: 'linear-gradient(to bottom, transparent 50%, #333046)',
      },
    },
    {
      coverId: 5012,
      template: 'horizen_1',
      title: {
        titleText: '',
        color: '#F3FF00',
        smallTitleColor: '#000',
        smallTitleBackground: 'linear-gradient(180deg, #F3FF00 0%, #EC1001 100%)',
        color_mask: '#EC1001',
        font: '潮字社曾玉波手书简',
        fontSize: '68',
        // strokeColor: "#fff",
        spacing: 0,
      },
      author: {
        authorText: '',
        fontSize: '18',
        color: '#fff',
      },
      padding: 20,
      background: {
        backgroundImage: 'https://raw.githubusercontent.com/lorryrio/godblesslorry.github.io.images/master/images/cover/dushi/12-cover.png',
        textBackground: 'linear-gradient(to bottom, transparent 50%, #333046)',
      },
    },
    {
      coverId: 5013,
      template: 'horizen_1',
      title: {
        titleText: '',
        color: '#FFFFFF',
        smallTitleColor: '#211621',
        smallTitleBackground: 'linear-gradient(180deg, #FFFFFF 0%, #EADCF1 100%)',
        color_mask: '#EADCF1',
        font: '联盟起艺卢帅正锐黑体',
        fontSize: '63',
        // strokeColor: "#fff",
        spacing: 0,
      },
      author: {
        authorText: '',
        fontSize: '18',
        color: '#fff',
      },
      padding: 20,
      background: {
        backgroundImage: 'https://raw.githubusercontent.com/lorryrio/godblesslorry.github.io.images/master/images/cover/dushi/13-cover.png',
        textBackground: 'linear-gradient(to bottom, transparent 50%, #333046)',
      },
    },
    {
      coverId: 5014,
      template: 'horizen_1',
      title: {
        titleText: '',
        color: '#FFFFFF',
        smallTitleColor: '#211621',
        smallTitleBackground: 'linear-gradient(180deg, #FFFFFF 0%, #EADCF1 100%)',
        color_mask: '#EADCF1',
        font: '联盟起艺卢帅正锐黑体',
        fontSize: '63',
        // strokeColor: "#fff",
        spacing: 0,
      },
      author: {
        authorText: '',
        fontSize: '18',
        color: '#fff',
      },
      padding: 20,
      background: {
        backgroundImage: 'https://raw.githubusercontent.com/lorryrio/godblesslorry.github.io.images/master/images/cover/dushi/14-cover.png',
        textBackground: 'linear-gradient(to bottom, transparent 50%, #333046)',
      },
    },
  ],
};

export default dushi;
